export class FetchModuleSlackFailure {
    static readonly type = '[Module] FetchModuleSlackFailure';
}
